import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';

const GET_REVIEWS_API = "https://eventscons.com/eventbackendnew/api/get-reviews";
const IMAGE_BASE_URL = "http://techzenondev.com/event/storage/app/public/";

const SingleClientV1 = () => {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    const getImageUrl = (src) => {
        if (!src) return "https://via.placeholder.com/120x120?text=User";
        if (src.startsWith("http://") || src.startsWith("https://")) return src;
        const cleanPath = src.replace(/^\/+/, "");
        return `${IMAGE_BASE_URL}${cleanPath}`;
    };

    const fetchReviews = async () => {
        try {
            setLoading(true);
            const res = await fetch(GET_REVIEWS_API);
            const data = await res.json();

            const finalReviews = Array.isArray(data)
                ? data
                : data?.data || data?.reviews || [];

            setReviews(finalReviews);
        } catch (error) {
            console.error("Error fetching reviews:", error);
            setReviews([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReviews();
    }, []);

    const renderStars = (rating) => {
        const totalStars = 5;
        return Array.from({ length: totalStars }, (_, index) => (
            <i
                key={index}
                className="fa fa-star"
                style={{
                    color: index < Number(rating) ? '#ffb400' : '#e5e7eb',
                    marginRight: '2px'
                }}
            />
        ));
    };

    return (
        <section
            className="testimonial-section"
            style={{ padding: '0px 0', backgroundColor: '#fff' }}
        >
            <div className="container customswiper">
                <div className="sec-title text-center" style={{ marginBottom: '10px' }}>
                    <h2
                        className="mainheadingfont"
                        style={{ fontSize: '42px', fontWeight: '700', color: '#000' }}
                    >
                        <span style={{ color: '#b21e35' }}>Reviews</span> from Real People
                    </h2>
                </div>

                {loading ? (
                    <div style={{ textAlign: "center", padding: "40px 0", color: "#666" }}>
                        Loading reviews...
                    </div>
                ) : reviews.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "40px 0", color: "#666" }}>
                        No reviews found.
                    </div>
                ) : (
                    <Swiper
                        modules={[Pagination, Autoplay]}
                        spaceBetween={30}
                        slidesPerView={1}
                        loop={reviews.length > 3}
                        speed={1000}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true
                        }}
                        pagination={{
                            clickable: true,
                            dynamicBullets: true
                        }}
                        breakpoints={{
                            768: { slidesPerView: 2 },
                            1024: { slidesPerView: 3 },
                        }}
                        style={{ padding: '20px 10px 70px 10px' }}
                    >
                        {reviews.map((item) => (
                            <SwiperSlide key={item.id} style={{ height: '320px' }}>
                                <div
                                    className="testimonial-card"
                                    style={{
                                        position: 'relative',
                                        padding: '30px 30px 40px',
                                        border: '1px solid #f2dada',
                                        borderRadius: '8px',
                                        textAlign: 'left',
                                        backgroundColor: '#fff',
                                        marginTop: '60px',
                                        height: '300px',
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '-60px',
                                            left: '30px',
                                            width: '120px',
                                            height: '120px',
                                            borderRadius: '50%',
                                            border: '6px solid #fff',
                                            outline: '1px solid #f2dada',
                                            overflow: 'hidden',
                                            zIndex: '2'
                                        }}
                                    >
                                        <img
                                            src={getImageUrl(item.image)}
                                            alt={item.name}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    </div>

                                    <div
                                        style={{
                                            textAlign: 'right',
                                            fontSize: '16px',
                                            marginBottom: '20px'
                                        }}
                                    >
                                        {renderStars(item.rating)}
                                    </div>

                                    <p
                                        style={{
                                            color: '#666',
                                            fontSize: '15px',
                                            lineHeight: '1.7',
                                            marginBottom: '30px',
                                            minHeight: '80px'
                                        }}
                                    >
                                        "{item.text}"
                                    </p>

                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h4
                                                style={{
                                                    fontSize: '19px',
                                                    fontWeight: '700',
                                                    margin: '0',
                                                    color: '#000'
                                                }}
                                            >
                                                {item.name}
                                            </h4>
                                            <span
                                                style={{
                                                    fontSize: '13px',
                                                    color: '#b21e35'
                                                }}
                                            >
                                                {item.designation}
                                            </span>
                                        </div>

                                        <div
                                            style={{
                                                fontSize: '120px',
                                                position: 'absolute',
                                                right: '40px',
                                                bottom: '-20px',
                                                color: '#f2dada',
                                                opacity: '0.6',
                                                fontFamily: 'serif',
                                                lineHeight: '1'
                                            }}
                                        >
                                            ”
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
            </div>

            <style>{`
                .swiper-pagination-bullet {
                    width: 14px;
                    height: 14px;
                    background: #ddd;
                    opacity: 1;
                }
                .swiper-pagination-bullet-active {
                    background: #888 !important;
                    transform: scale(1.2);
                }
            `}</style>
        </section>
    );
};

export default SingleClientV1;